import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import Combobox from './Combobox';

const FormSelector = ({readonly, ...restProps}) => (
  <Col lg={6} xs={12}>
    <Combobox 
      style={{ background: '#607d8b', color: '#fff', fontWeight: 500 }}
      disabled={readonly}
      {...restProps}
    />
  </Col>
)

FormSelector.propTypes = {
  readonly: PropTypes.bool
}

export default FormSelector;